function toggleSearch() {
    const searchBlock = document.querySelector('.js--search-block');
    if (searchBlock === null) return;
    const blockLogo = document.querySelector('.header__block-logo');
    const blockSearch = document.querySelector('.header__block-search');
    const blockSearchIcon = document.querySelector('.header__search-icons');
    const blockBurger = document.querySelector('.header__burger-wrapper');
    const logoLens = document.querySelector('.header__search-logo--main');
    const logoLensBack = document.querySelector('.header__search-logo--alt');
    const blocksArray = [
        {
            block: blockLogo,
            name: 'blockLogo'
        },
        {
            block: blockSearch,
            name: 'blockSearch'
        },
        {
            block: blockBurger,
            name: 'blockBurger'
        },
        {
            block: logoLens,
            name: 'logoLens'
        },
        {
            block: logoLensBack,
            name: 'logoLensBack'
        },
        {
            block: blockSearchIcon,
            name: 'blockSearchIcon'
        },

    ];

    let error = blocksArray.filter(({ block, name }) => {
        if (block === null) {
            console.log(`block ${name} not found`);
            return true;
        }
        return false;
    }).length;

    if (error > 0) {
        return;
    }

    blockSearchIcon.addEventListener('click', function() {
        blockLogo.classList.toggle('header__block-logo--hidden');
        blockBurger.classList.toggle('header__burger-wrapper--hidden');
        logoLens.classList.toggle('header__search-logo--hidden');
        logoLensBack.classList.toggle('header__search-logo--hidden');
        blockSearch.classList.toggle('header__block-search--active');
    })
}

toggleSearch();